module.exports = __webpack_public_path__ + "static/media/black-dollar.706c40f1.svg";